import { apiError } from '../../utils/errors';

export const patchSubmission = async (
  urlSlug: string,
  publicId: string,
  responses: Record<string, unknown>,
  userType: string,
): Promise<void> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/submissions/${urlSlug}/${publicId}?userType=${userType}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ responses }),
    credentials: 'include',
  });

  const responseJson = await response.json();
  if (!response.ok) {
    throw apiError(response.status, responseJson?.message || 'Failed to fetch application', responseJson.code);
  }
};
